<app-header [hidden]="hiddingHeaderFooter"></app-header>

    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Training & Assessment Materials Search
    </div>
    <form
      nz-form
      [formGroup]="searchForm"
      class="ant-advanced-search-form"
      (ngSubmit)="submitSearchForm()"
      style="
        padding: 24px;
        background: #fbfbfb;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
      "
    >
      <div nz-row [nzGutter]="24">
        <div class="col-lg-2 col-md-12">
          <nz-form-item>
            <nz-form-label>ID</nz-form-label>
            <nz-form-control>
              <input
                nz-input
                placeholder="ID"
                formControlName="tamApplicationId"
                id="tamApplicationId"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div  class="col-lg-5 col-md-12">
          <nz-form-item>
            <nz-form-label>Document Type</nz-form-label>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                id="tamTypeId"
                formControlName="tamTypeId"
                nzPlaceHolder="Select Document Type"
              >
                <nz-option
                  class="option"
                  *ngFor="let data of tamTypes"
                  [nzValue]="data.id"
                  [nzLabel]="data.name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="col-lg-5 col-md-12">
          <nz-form-item>
            <nz-form-label>Access Type</nz-form-label>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                id="isPublished"
                formControlName="isPublished"
                nzPlaceHolder="Select Access Type">
                <nz-option class="option" nzValue="true" nzLabel="Public">
                </nz-option>
                <nz-option
                  class="option"
                  nzValue="false"
                  nzLabel="Limited">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="24">
        <div class="col-lg-6 col-md-12">
          <nz-form-item>
            <nz-form-label>Sector</nz-form-label>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                id="industrialSectorId"
                formControlName="industrialSectorId"
                nzPlaceHolder="Select Sector"
              >
                <nz-option
                  class="option"
                  *ngFor="let data of tamIndustrialSectors"
                  [nzValue]="data.id"
                  [nzLabel]="data.name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="col-lg-6 col-md-12">
          <nz-form-item>
            <nz-form-label>Occupation</nz-form-label>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                id="tamOccupationId"
                formControlName="tamOccupationId"
                nzPlaceHolder="Select Occupation"
              >
                <nz-option
                  class="option"
                  *ngFor="let data of tamOccupations"
                  [nzValue]="data.id"
                  [nzLabel]="data.name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>



      <div class="col-lg-6 col-md-12">
        <nz-form-item>
          <nz-form-label>Status Type</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              id="status"
              formControlName="status"
              nzPlaceHolder="Select Status Type">
              <!-- <nz-option class="option" nzValue=0 nzLabel="Drafted">
               </nz-option>
               <nz-option class="option" nzValue=2 nzLabel="Submitted">
               </nz-option> -->

              <nz-option
                class="option"
                *ngFor="let data of statusOptions"
                [nzValue]="data.value"
                [nzLabel]="data.label"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>



      <div nz-row>
        <div nz-col [nzSpan]="24" class="search-area">
          <button class="col-md-2 col-sm-12 mt-2" nz-button [nzType]="'primary'">Search</button>
          <button class="col-md-2 col-sm-12 mt-2" nz-button (click)="resetForm()">Refresh Data</button>
          <button *ngIf="userInfo?.roles != null" class="col-md-2 col-sm-12 mt-2" nz-button routerLink="/home/training-and-assessment-materials/tam-create">Add TAM</button>
          <button class="col-md-2 col-sm-12 mt-2" nz-button
          [appRequiredPermission]="applicationPermissions.tam.archive.readPermission"
           routerLink="/home/training-and-assessment-materials/tam-archive-list">TAM Archive List</button>
          <button class="btn-dark col-md-12 col-lg-2 mt-2" nz-button (click)="onDownloadReport()">
            Download Report
          </button>
        </div>
      </div>
    </form>


    <div class="ng-Header col-xs-12 mt-4">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Training & Assessment Materials List
    </div>
    <div nz-col [nzSpan]="24">
      <nz-table
        #basicTable
        [nzData]="tamMainSearchResultDto"
        nzTableLayout="fixed"
        nzShowSizeChanger
        nzBordered
        nzSize="middle"
        nzAlign="middle"
        [nzFrontPagination]="false"
        [nzTotal]="total"
        [(nzPageSize)]="pageSize"
        [nzShowTotal]="totalRowRangeTemplate"
        [(nzPageIndex)]="currentPage"
        (nzQueryParams)="onQueryParamsChange($event)"
        [nzScroll]="{ x: '1150px' }"
      >
        <ng-template
          #totalRowRangeTemplate
          let-range="range"
          let-total
          style="text-align: left"
        >
          <div style="text-align: left">
            Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
          </div>
        </ng-template>
  <!-- <nz-card>
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Training & Assessment Materials List
    </div>
    <div class="searchboxAerar p-3">
      <nz-table
        nzSize="small"
        #basicTable
        [nzData]="tamMains"
        nzShowSizeChanger
        nzBordered
        nzAlign="middle"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        class="css-serial table-striped table"
      > -->
        <thead>
          <tr>
            <th style="text-align: center; vertical-align: middle; width: 40px;">SI.</th>
            <th style="text-align: center; vertical-align: middle">ID</th>
            <th style="text-align: center; vertical-align: middle" nzColumnKey="tamType.id" [nzSortFn]="true">
              Document Type
            </th>
            <th style="text-align: center; vertical-align: middle" nzColumnKey="tamOccupation.tamIndustrialSector.id" [nzSortFn]="true">Sector</th>
            <th style="text-align: center; vertical-align: middle" nzColumnKey="tamOccupation.id" [nzSortFn]="true">
              Occupation
            </th>
            <th style="text-align: center; vertical-align: middle" nzColumnKey="tamLevel.id" [nzSortFn]="true">Level</th>
            <!-- <th style="text-align: center; vertical-align: middle">
              Document Title
            </th> -->
            <th style="text-align: center; vertical-align: middle" nzColumnKey="tamLanguage.id" [nzSortFn]="true">Language</th>
            <th style="text-align: center; vertical-align: middle" nzColumnKey="approvalDate" [nzSortFn]="true">
              Date of Approval
            </th>
            <th *ngIf="userInfo?.roles != null" style="text-align: center; vertical-align: middle" nzColumnKey="status" [nzSortFn]="true">Status</th>
            <th *ngIf="userInfo?.roles != null" style="text-align: center; vertical-align: middle" nzColumnKey="isPublished" [nzSortFn]="true">Access Type</th>

            <!-- <th style="text-align: center; vertical-align: middle" nzColumnKey="status" [nzSortFn]="true">Status</th>
            <th style="text-align: center; vertical-align: middle" nzColumnKey="isPublished" [nzSortFn]="true">Access Type</th> -->
            <th nzRight style="text-align: center; vertical-align: middle"> {{((this.userInfo?.roles == null) || (this.userInfo?.roles[0].name === 'admin')) ? "Download" : "Action" }} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td style="text-align: center">{{ (currentPage - 1) * pageSize + 1 + i }}</td>
            <td style="text-align: center; vertical-align: middle" (click)="selectedCourseAccreditationDocument(data.id)">
              <a style="color:#007bff!important">
                {{ data.tamApplicationId }}</a>
            </td>
            <td style="text-align: center; vertical-align: middle">
              {{ data.tamTypeName }}
            </td>
            <td style="text-align: center; vertical-align: middle">
              {{ data.tamIndustrialSectorName }}
            </td>
            <td style="text-align: center; vertical-align: middle">
              {{ data.tamOccupationName }}
            </td>
            <td style="text-align: center; vertical-align: middle">
              {{ data.tamLevelId }}
            </td>
            <!-- <td style="text-align: center; vertical-align: middle">
              {{ data.docTitle }}
            </td> -->
            <td style="text-align: center; vertical-align: middle">
              {{ data.tamLanguageName }}
            </td>
            <td style="text-align: center; vertical-align: middle">
              {{ data.approvalDate | date: "dd-MM-YYYY" }}
            </td>
            <td *ngIf="userInfo?.roles != null" style="text-align: center; vertical-align: middle">
              <span *ngIf="data.status === 2" _ngcontent-fwt-c639="" ng-reflect-ng-class="badge badge-success fontSize" class="badge badge-success fontSize"  style="font-size: 12px">Submitted</span>
              <span *ngIf="data.status !== 2" _ngcontent-fwt-c639="" ng-reflect-ng-class="badge badge-warning fontSize" class="badge badge-warning fontSize" style="font-size: 12px">Drafted</span>
            </td>
            <td *ngIf="userInfo?.roles != null" style="text-align: center; vertical-align: middle">
              {{ data.isPublished === true ? "Public" : "Limited" }}
            </td>
            <td nzRight style="text-align: center; vertical-align: middle">
              <div
                [appRequiredPermission]="applicationPermissions.tam.tam.updatePermission"
              >
                <button
                  [appRequiredPermission]="applicationPermissions.tam.tam.updatePermission"
                  title="Edit"
                  (click)="onEdit(data.id)"
                  [hidden]="((this.userInfo?.roles == null) || (this.userInfo?.roles[0].name === 'admin'))"
                  nz-button
                  class="mr-1"
                  nzType="primary"
                  [nzSize]="'small'"
                >
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </button>
              </div>

<!--              attachment button cblm-->
<!--              <div>-->
<!--                <button-->
<!--                  class="mr-1 mt-1"-->
<!--                  title="Print Attachments Data"-->
<!--                  (click)="getCblmAttachments(data)"-->
<!--                  nz-button-->
<!--                  nzType="default"-->
<!--                  [nzSize]="'small'"-->
<!--                >-->
<!--                  <i nz-icon nzType="printer" nzTheme="outline"></i>-->
<!--                </button>-->
<!--              </div>-->

              <div>
                <button
                  class="mr-1 mt-1"
                  title="Download"
                  (click)="onDownload(data)"
                  [hidden]="(!data?.isPublished == true) && ((this.userInfo?.roles == null) || (this.userInfo?.roles[0].name === 'User'))"
                  nz-button
                  nzType="primary"
                  [nzSize]="'small'"
                >
                  <i nz-icon nzType="download" nzTheme="outline"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <!-- <nz-pagination
        [nzPageIndex]="currentPage"
        [nzTotal]="totalData"
        [nzPageSize]="pageSize"
        (nzPageIndexChange)="onPageIndexChange($event)"
        [nzShowTotal]="rangeTemplate"
      ></nz-pagination> -->
      <!-- <ng-template #totalTemplate let-total
        >Total {{ totalData }} items</ng-template> -->
      <!-- <ng-template #rangeTemplate let-range="range" let-total>
        {{ range[0] }}-{{ range[1] }} of {{ totalData }} items
      </ng-template> -->
    </div>


<app-footer [hidden]="hiddingHeaderFooter"></app-footer>
